'use client';

import { InfoTooltip, type InfoTooltipProps } from '@cc-shopping/ui/composites/InfoTooltip';
import { useMonetizingTooltipPageAction } from 'src/features/product-card/DriversLegacy/hooks';

export function DriverValueTooltip({
  driverKey,
  segmentActionSection,
  ...tooltipProps
}: InfoTooltipProps & {
  driverKey: string;
  segmentActionSection?: string;
}) {
  const handleTooltipClickPageAction = useMonetizingTooltipPageAction();

  return (
    <InfoTooltip
      {...tooltipProps}
      {...(segmentActionSection && {
        onOpen: () => handleTooltipClickPageAction(driverKey, 'open', segmentActionSection),
        onClose: () => handleTooltipClickPageAction(driverKey, 'close', segmentActionSection),
        onBlur: () => handleTooltipClickPageAction(driverKey, 'close', segmentActionSection),
      })}
    />
  );
}
